import {configureStore} from '@reduxjs/toolkit';
import lists from './listsSlice';
import settings from './settingsSlice'
import license from './licenseSlice'
import jobs from "./jobsSlice";
import friends from "./friendSlice";
import account from "./accountSlice";
import carProps from "./carPropsSlice"

export default configureStore({
    reducer: {
        lists: lists,
        settings: settings,
        license: license,
        jobs: jobs,
        friends: friends,
        account: account,
        carProps: carProps
    },
});